const Packery = require('packery');

export default () => {
    const grids = document.querySelectorAll('.js-packery');
    if (grids.length) {
        const insts = [];
        for (const grid of grids) {
            const pck = new Packery( grid, {
                itemSelector: '.image-content-list__image-item',
            });
            insts.push(pck);
        }

        window.addEventListener("load", () => {
            for (const pck of insts) {
                pck.layout();
            }
        });
    }


}
